import { useEffect, useState } from "react";
import DashboardShell from "@/components/DashboardShell";
import { api, fmtNGN, formatErr } from "@/lib/api";
import { toast } from "sonner";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [filter, setFilter] = useState("all");
  useEffect(() => { api.get("/admin/users").then((r) => setUsers(r.data)); }, []);

  const visible = filter === "all" ? users : users.filter((u) => u.role === filter);

  const payout = async (uid) => {
    try { const { data } = await api.post(`/admin/agents/${uid}/payout`); toast.success(`Paid out ${fmtNGN(data.paid)} (Salary ${fmtNGN(data.salary)} + Commission ${fmtNGN(data.commission)})`); }
    catch (e) { toast.error(formatErr(e?.response?.data?.detail) || e.message); }
  };

  const setSalary = async (uid) => {
    const v = window.prompt("Set monthly salary (₦) for this DSA:", "0");
    if (v == null) return;
    const n = Number(v);
    if (Number.isNaN(n) || n < 0) return toast.error("Enter a valid amount");
    try { await api.post(`/admin/agents/${uid}/salary`, { monthly_salary_ngn: n }); toast.success(`Salary set to ${fmtNGN(n)}/month`); }
    catch (e) { toast.error(formatErr(e?.response?.data?.detail) || e.message); }
  };

  return (
    <DashboardShell title="Users" subtitle={`${users.length} users on the platform`}
      actions={
        <select className="input !py-2 !px-3 text-sm w-44" value={filter} onChange={(e) => setFilter(e.target.value)} data-testid="users-filter">
          <option value="all">All roles</option>
          <option value="school">Schools</option>
          <option value="parent">Parents</option>
          <option value="agent">Agents</option>
          <option value="admin">Admins</option>
        </select>
      }>
      <div className="card">
        <table className="dense">
          <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Joined</th><th>Referral</th><th>Action</th></tr></thead>
          <tbody>
            {visible.map((u) => (
              <tr key={u.id} data-testid={`user-row-${u.id}`}>
                <td className="font-medium">{u.name}</td>
                <td>{u.email}</td>
                <td><span className="badge badge-info">{u.role}</span></td>
                <td>{new Date(u.created_at).toLocaleDateString()}</td>
                <td className="font-mono text-xs">{u.referral_code || "—"}</td>
                <td>{u.role === "agent" && (
                  <span className="space-x-1">
                    <button onClick={() => setSalary(u.id)} className="btn-outline !py-1 !px-3 text-xs" data-testid={`set-salary-${u.id}`}>Set salary</button>
                    <button onClick={() => payout(u.id)} className="btn-outline !py-1 !px-3 text-xs" data-testid={`payout-${u.id}`}>Payout</button>
                  </span>
                )}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </DashboardShell>
  );
}
